<template>
  <v-card flat class="futuristic-card">
    <v-tabs slider-color="primary" v-model="activeTab">
      <v-tab key="allVehicles" ripple class="earth-color">ALL VEHICLES</v-tab>
      <v-tab key="addVehicle" ripple class="earth-color">ADD VEHICLE</v-tab>
      <v-tab key="editVehicle" ripple class="earth-color">EDIT VEHICLE</v-tab>
      
      <v-tab-item key="allVehicles">
        <v-card-title class="card-header">
          <h4 class="earth-color">ALL VEHICLES</h4>
          <v-spacer></v-spacer>
          <v-text-field
            append-icon="mdi-magnify"
            label="Search Vehicles"
            single-line
            hide-details
            v-model="search"
            class="futuristic-input"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="columns"
          :items="allAutos"
          :search="search"
          :items-per-page-options="[10, 25, { text: 'All', value: -1 }]"
          :disable-initial-sort="true"
          :loading="loading"
          class="futuristic-table"
        >
          <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.auto }}</td>
            <td class="action-buttons">

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      small
                      color="primary"
                      @click="viewAuto(props.item.public_id)"
                      class="futuristic-btn white--text"
                      v-on="on"
                    >
                      <v-icon small left>mdi-eye</v-icon>
                      View
                    </v-btn>
                  </template>
                  <span>View Vehicle Details</span>
                </v-tooltip>

                                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      small
                      color="warning"
                      @click="editAutoModal(props.item)"
                      class="futuristic-btn white--text"
                      v-on="on"
                    >
                      <v-icon small left>mdi-pencil</v-icon>
                      Edit
                    </v-btn>
                  </template>
                  <span>Edit Vehicle</span>
                </v-tooltip>

                                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      small
                      color="error"
                      @click="deleteAuto(props.item.public_id)"
                      class="futuristic-btn white--text"
                      v-on="on"
                    >
                      <v-icon small left>mdi-delete</v-icon>
                      Delete
                    </v-btn>
                  </template>
                  <span>Delete Vehicle</span>
                </v-tooltip>
            </td>
          </template>
          <template v-slot:no-data>
            <v-alert :value="true" color="info" icon="mdi-information" class="futuristic-alert">
              {{ allAutos.length === 0 ? 'No vehicles available. Add a vehicle to get started.' : 'No matching vehicles found.' }}
            </v-alert>
          </template>
          <template v-slot:footer>
            <td :colspan="columns.length" class="footer-cell">
              <vue-json-to-csv
                :json-data="allAutos"
                csv-title="Vehicles List"
                :labels="{
                  id: { title: 'ID' },
                  auto: { title: 'Vehicle Name' },
                  //public_id: { title: 'Public ID' }
                }"
              >
                <v-btn depressed color="primary" class="futuristic-btn">
                  <v-icon left>mdi-download</v-icon>
                  <b>Download CSV</b>
                </v-btn>
              </vue-json-to-csv>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            class="futuristic-alert"
          >
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-tab-item>
      
      <v-tab-item key="addVehicle">
        <v-card-title class="card-header">
          <h4 class="earth-color">ADD NEW VEHICLE</h4>
        </v-card-title>
        <v-card-text>
          <v-form ref="addForm" v-model="validAdd" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="newAuto.auto"
                    label="Vehicle Name"
                    :rules="autoNameRules"
                    required
                    class="futuristic-input"
                    prepend-icon="mdi-car"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn 
                :disabled="!validAdd || addLoading" 
                color="primary" 
                @click="addAuto" 
                class="futuristic-btn"
                :loading="addLoading"
              >
                <v-icon left>mdi-plus</v-icon>
                Add Vehicle
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-tab-item>
      
      <v-tab-item key="editVehicle">
        <v-card-title class="card-header">
          <h4 class="earth-color">EDIT VEHICLE</h4>
          <v-spacer></v-spacer>
          <v-select
            v-model="selectedAuto"
            :items="allAutos"
            item-text="auto"
            item-value="public_id"
            label="Select Vehicle to Edit"
            return-object
            class="futuristic-input"
            style="max-width: 300px;"
            prepend-icon="mdi-car-search"
          ></v-select>
        </v-card-title>
        
        <v-card-text v-if="selectedAuto">
          <v-form ref="editForm" v-model="validEdit" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="selectedAuto.auto"
                    label="Vehicle Name"
                    :rules="autoNameRules"
                    required
                    class="futuristic-input"
                    prepend-icon="mdi-car"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
            
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn 
                :disabled="!validEdit || editLoading" 
                color="warning" 
                @click="updateAuto" 
                class="futuristic-btn"
                :loading="editLoading"
              >
                <v-icon left>mdi-content-save</v-icon>
                Update Vehicle
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
        
        <v-card-text v-else>
          <v-alert :value="true" color="info" icon="mdi-information" class="futuristic-alert">
            Select a vehicle from the dropdown to edit its details.
          </v-alert>
        </v-card-text>
      </v-tab-item>
    </v-tabs>
    
    <!-- Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>
          Are you sure you want to delete vehicle: <strong>{{ autoToDelete.name }}</strong>?
          <br><br>
          <small class="text--secondary">This action will delete the vehicle.</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" text @click="confirmDelete" :loading="deleteLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <!-- Snackbar for messages -->
    <v-snackbar 
      v-model="snackbar.show" 
      :color="snackbar.color" 
      :top="snackbar.top"
      :right="snackbar.right"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.message }}
      <v-btn text @click="snackbar.show = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import VueJsonToCsv from "vue-json-to-csv";

export default {
  name: 'Autos',
  components: { 
    VueJsonToCsv 
  },
  computed: {
    autoErrors() {
      return (this.$store.state.autos && this.$store.state.autos.errors) ? this.$store.state.autos.errors : [];
    }
  },
  data() {
    return {
      activeTab: 0,
      search: "",
      loading: false,
      addLoading: false,
      editLoading: false,
      deleteLoading: false,
      deleteDialog: false,
      validAdd: false,
      validEdit: false,
      selectedAuto: null,
      autoToDelete: {
        public_id: '',
        name: ''
      },
      newAuto: {
        auto: ''
      },
      snackbar: {
        show: false,
        message: '',
        color: 'success',
        top: true,
        right: true,
        timeout: 3000
      },
      columns: [
        { text: "ID", value: "id", sortable: true },
        { text: "Vehicle Name", value: "auto", sortable: true },
        //{ text: "Public ID", value: "public_id" },
        { text: "Actions", value: "actions", sortable: false, width: '150px' }
      ],
      autoNameRules: [
        v => !!v || 'Vehicle name is required',
        v => (v && v.length >= 2) || 'Vehicle name must be at least 2 characters'
      ]
    };
  },
  created() {
    this.loading = true;
    this.$store.dispatch("get_all_autos").finally(() => {
      this.loading = false;
    });
  },
  watch: {
    autoErrors: {
      handler(errors) {
        if (errors && errors.length > 0) {
          this.showMessage(errors[0], 'error');
        }
      },
      deep: true
    }
  },
  methods: {
    addAuto() {
      if (!this.$refs.addForm.validate()) return;
      
      this.addLoading = true;
      this.$store.dispatch("post_auto", {
        auto: this.newAuto.auto.trim()
      }).then(function(response) {
        this.newAuto = { auto: '' };
        this.$refs.addForm.resetValidation();
        this.showMessage(response.data.message[0], 'success');
        this.activeTab = 0;
      }.bind(this)).catch(function(error) {
        console.error('Error adding vehicle:', error);
        this.showMessage(error.response.data.message[0], 'error');
      }.bind(this)).finally(function() {
        this.addLoading = false;
      }.bind(this));
    },
    
    updateAuto() {
      if (!this.$refs.editForm.validate()) return;
      
      this.editLoading = true;
      this.$store.dispatch("update_auto", {
        public_id: this.selectedAuto.public_id,
        auto: this.selectedAuto.auto.trim()
      }).then(function(response) {
        this.selectedAuto = null;
        this.showMessage(response.data.message[0], 'success');
      }.bind(this)).catch(function(error) {
        console.error('Error updating vehicle:', error);
        this.showMessage(error.response.data.message[0], 'error');
      }.bind(this)).finally(function() {
        this.editLoading = false;
      }.bind(this));
    },
    
    deleteAuto(public_id) {
      const auto = this.allAutos.find(a => a.public_id === public_id);
      if (auto) {
        this.autoToDelete = {
          public_id: public_id,
          name: auto.auto
        };
        this.deleteDialog = true;
      }
    },
    
    confirmDelete() {
      this.deleteLoading = true;
      this.$store.dispatch("delete_auto", {
        public_id: this.autoToDelete.public_id
      }).then(function(response) {
        this.deleteDialog = false;
      }.bind(this)).catch(function(error) {
        console.error('Error deleting vehicle:', error);
        this.showMessage(error.response.data.message[0], 'error');
      }.bind(this)).finally(function() {
        this.deleteLoading = false;
      }.bind(this));
    },
    
    viewAuto(public_id) {
      this.showMessage('Viewing vehicle details for ID: ' + public_id, 'info');
    },
    
    editAutoModal(auto) {
      this.selectedAuto = { ...auto };
      this.activeTab = 2;
    },
    
    showMessage(message, type) {
      var color = 'success';
      if (type === 'error') {
        color = 'red';
      } else if (type === 'info') {
        color = 'blue';
      }
      
      this.snackbar = {
        show: true,
        message: message,
        color: color,
        top: true,
        right: true,
        timeout: 3000
      };
    }
  }
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  margin: 0 8px 8px;
}

.futuristic-table >>> table {
  border-collapse: separate;
  border-spacing: 0;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
  font-size: 13px;
}

.futuristic-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f5f7fa;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 8px;
}

/* Style for v-tabs */
.v-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.v-tabs >>> .v-tabs__item {
  text-transform: none;
  font-weight: 500;
}

/* Footer cell styling */
.footer-cell {
  padding: 16px;
  text-align: center;
}

/* Action buttons styling */
.action-buttons {
  min-width: 150px;
  white-space: nowrap;
}

.action-buttons .futuristic-btn {
  margin: 0 4px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
  }

  .futuristic-input {
    max-width: 100%;
    margin-top: 12px;
  }

  .futuristic-table {
    margin: 0 4px 4px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-table >>> tbody tr td {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table {
    margin: 0 4px 4px;
    overflow-x: auto;
  }

  .futuristic-table >>> table {
    min-width: 500px;
  }

  .futuristic-table >>> thead {
    display: table-header-group;
  }

  .futuristic-table >>> tbody tr {
    display: table-row;
  }

  .futuristic-table >>> tbody tr td {
    display: table-cell;
    font-size: 0.85rem;
    padding: 6px 8px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 0.85rem;
    padding: 6px 8px;
  }
  
  .action-buttons {
    min-width: 120px;
  }
  
  .action-buttons .futuristic-btn {
    margin: 0 2px;
    padding: 4px !important;
  }
}

/* Action buttons in table */
.mr-2 {
    margin-right: 8px !important;
}
</style>